import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatSelectionList } from '@angular/material/list';
import { delay } from 'rxjs/operators';

import { FileDataService } from '../services/file-data.service';
import { MapSharedService } from '../services/map-shared.service';
import { IItineraryRoute } from './itinerary-route';
import { Subscription } from 'rxjs';
import { IMapTypes } from '../../map-settings/settings';
import * as L from 'leaflet';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/user/services/auth.service';


@Component({
  selector: 'app-itinerary-route',
  templateUrl: './itinerary-route.component.html',
  styleUrls: ['./itinerary-route.component.scss']
})
export class ItineraryRouteComponent implements OnInit {
  @ViewChild('routeSelection') routeSelection: MatSelectionList;
  itineraryRouteList: IItineraryRoute[] = [];
  subs: Subscription[] = [];
  public remove: IItineraryRoute;
  public routeFlag: boolean = true;
  constructor(private fileService: FileDataService,
    private sharedService: MapSharedService,
    private authService: AuthService, 
    private router: Router  
  ) { }

  ngOnInit(): void {
    this.fileService.currentItineraryRouteData$.subscribe(
      (routeData: IItineraryRoute[]) => {
        if (routeData.length) {
          this.itineraryRouteList = routeData;
        }
      }
    )
  }
  ngAfterViewInit() {

    this.defaultSelectionForAddedRoute();
    this.onListSelectionChanges();
  }
  /**
   * On Adding new route to list,
   * default value of checkbox is set to 'SELECTED' and
   * other routes in the list remain undisturbed
   */
  defaultSelectionForAddedRoute() {
    this.fileService.writeLog("defaultSelectionForAddedRoute-start").subscribe((data:any)=>{

    })
    this.subs.push(
         this.routeSelection.options.changes
        .pipe(
          delay(100)
        ).subscribe(
          res => {
            if(res.last != null) {
              res.last.selected = true;   
            }       
    }
          
));
        this.fileService.writeLog("defaultSelectionForAddedRoute-end").subscribe((data:any)=>{

        })
  }
  /**
   * Handles adding and removing the `ITINERARY_ROUTE` to the map
   * based on checkbox selection
   */
  onListSelectionChanges() {
    this.fileService.writeLog("onListSelectionChanges-start").subscribe((data:any)=>{

    })
    this.subs.push(
      this.routeSelection.selectedOptions.changed.subscribe(
        res => {
          if (res.added.length) {
            this.fileService.writeLog("onListSelectionChanges-start").subscribe((data:any)=>{

            })
            res.added.forEach(list => {
              this.sharedService.compareItineraryRoute(list.value);
            })
            this.fileService.writeLog("onListSelectionChanges-end").subscribe((data:any)=>{

            })
          }
          if (res.removed.length) {
            this.fileService.writeLog("onListSelectionChanges-start").subscribe((data:any)=>{

            })
            res.removed.forEach(list => {
              this.sharedService.removeItineraryRoute(list.value);
            })
            this.fileService.writeLog("onListSelectionChanges-end").subscribe((data:any)=>{

            })
          }
        }
      ));
      
  }

  deleteRoute(i: number) {
    // const message =
    //   "Do you want to remove this route?";
    // const dialogRef = this.confirmDialog.open(ConfirmDialogComponent, {
    //   width: "28rem",
    //   data: message,
    //   disableClose: false,
    // });
    // dialogRef.afterClosed().subscribe((result) => {
    //   if (result.saveData) {
    //     let removeArry = this.itineraryRouteList.splice(i, 1);
    //     this.remove = removeArry[0];
    //     this.fileService.changeItineraryRouteData(this.itineraryRouteList);
    //   }
    // });   
    
   
  this.fileService.writeLog("deletePolygon").subscribe((data:any)=>{

  })
   this.itineraryRouteList.splice(i,1);
   this.fileService.changeItineraryRouteData(this.itineraryRouteList); 
  }
 
  addNewRoute() {  
    this.fileService.writeLog("addNewRoute-start").subscribe((res:any)=> { 
       if (res.responseCode != null && res.responseCode.statusCode === 401) {
        this.authService.logout();
        this.router.navigate(['/user/login']);
      } else {
        this.fileService.addItineraryRoute(true);
        this.fileService.writeLog("addNewRoute-end").subscribe((data:any)=>{      
        })
      }
    },
      (err) => console.log("Error while add route: ", err)
    );
  }
  
  ngOnDestroy(): void {
    this.fileService.changeItineraryRouteData([]);
    this.subs.forEach(sub => sub.unsubscribe());
  }
  

}
